import React from "react";
import PropTypes from "prop-types";
import LangSwitcher from "../../../Component/LangSwitcher";
import AuthHero from "./AuthHero";

const AuthShell = ({ wide = false, heroVariant = "login", children }) => (
  <div className="auth-page">
    <LangSwitcher className="auth-lang" />
    <div className="auth-wrap">
      <div className={`auth-panel ${wide ? "wide" : ""}`}>{children}</div>
      <AuthHero variant={heroVariant} />
    </div>
  </div>
);

AuthShell.propTypes = {
  wide: PropTypes.bool,
  heroVariant: PropTypes.oneOf(["login", "register"]),
  children: PropTypes.node.isRequired
};

export default AuthShell;
